import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            当下最受漫友关注的热议话题，看看大家都在讨论什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group flex items-center gap-3 px-5 py-3 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 border ${
                item.color === 'accent'
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100/70'
                  : item.color === 'primary'
                    ? 'bg-primary-50 border-primary-200 hover:bg-primary-100/70'
                    : 'bg-secondary-50 border-secondary-200 hover:bg-secondary-100/70'
              }`}
            >
              <span
                className={`font-semibold text-sm whitespace-nowrap ${
                  item.color === 'accent'
                    ? 'text-accent-700'
                    : item.color === 'primary'
                      ? 'text-primary-700'
                      : 'text-secondary-800'
                }`}
              >
                {item.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}